import { MessageCircle } from 'lucide-react'
import { motion } from 'framer-motion'

import { usePublicSiteBundle } from '@/hooks/usePublicSiteBundle'

/**
 * Floating WhatsApp button — only renders when a WhatsApp number
 * is configured in site settings (integrations.social.whatsapp).
 */
export function WhatsAppButton() {
  const bundle = usePublicSiteBundle()

  const whatsapp = (() => {
    const int = bundle.data?.site_config?.integrations
    if (!int || typeof int !== 'object') return ''
    const s = (int as Record<string, unknown>).social
    if (!s || typeof s !== 'object') return ''
    const w = (s as Record<string, unknown>).whatsapp
    return typeof w === 'string' ? w.trim() : ''
  })()

  if (!whatsapp) return null

  // Clean number: remove spaces, dashes, keep + prefix
  const cleanNumber = whatsapp.replace(/[\s\-()]/g, '')
  const href = `https://wa.me/${cleanNumber.replace(/^\+/, '')}`

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: 'spring', stiffness: 260, damping: 20 }}
      className="fixed bottom-6 end-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-600/30 transition-transform hover:scale-110 active:scale-95"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2} />
    </motion.a>
  )
}
